const ID_TOKEN_KEY = "token_authlogos";

export const getToken = () => {
    return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = token => {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
    window.localStorage.removeItem(ID_TOKEN_KEY);
};

export const criarObterGenerico = (configuracao, valor) => {
    let valorSalvo = window.localStorage.getItem(configuracao);

    if (valorSalvo) {
        return valorSalvo;
    } else {
        window.localStorage.setItem(configuracao, valor);
        return valor;
    }
};

export const salvarGenerico = (configuracao, valor) => {
    window.localStorage.setItem(configuracao, valor);
};

export default { getToken, saveToken, destroyToken, criarObterGenerico, salvarGenerico };